import useCreateGSClient from './hooks/useCreateGSClient';
import useMonitorGSEvents from './hooks/useMonitorGSEvents';

const GetstreamVideoComp = () => {
    useCreateGSClient();
    useMonitorGSEvents();

    return null;
};

export default GetstreamVideoComp;